import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { DynamicFormOptions } from '../models/edit-fields';
import { Observable } from 'rxjs';
import { ServerTypes } from 'src/app/models/servers';
import { ApiService } from 'src/app/services/api.service';

@Injectable({ providedIn: 'root' })
export class DynamicFormApi {
  constructor(private httpClient: HttpClient, private apiService: ApiService) {}

  postForm(formGroup: UntypedFormGroup, options: DynamicFormOptions): Observable<any> {
    const url = this.createUrl(options.serverType, options.saveFormUrl);
    return this.httpClient.request(options.saveFormMethod, url, {
      body: this.normalizeBody(formGroup.getRawValue(), options),
    });
  }

  private normalizeBody(
    body: { [key: string]: any },
    options: DynamicFormOptions
  ): { [key: string]: any } {
    const checkboxIds = new Set(
      options.fields.filter((f) => f.type === 'checkbox').map((f) => f.id)
    );
    const result: { [key: string]: any } = {};
    Object.keys(body).forEach((key) => {
      if (checkboxIds.has(key)) result[key] = !!body[key];
      else result[key] = body[key] === '' ? null : body[key];
    });
    return result;
  }

  get(options: DynamicFormOptions): Observable<any> {
    const url = this.createUrl(options.serverType, options.getFormUrl);
    return this.httpClient.get(url);
  }

  getSelectOptions(
    options: DynamicFormOptions,
    selectOptionsUrl: string
  ): Observable<any> {
    const url = this.createUrl(options.serverType, selectOptionsUrl);
    return this.httpClient.get(url);
  }

  delete(options: DynamicFormOptions): Observable<any> {
    const url = this.createUrl(options.serverType, options.deleteFormUrl);
    return this.httpClient.delete(url);
  }

  private createUrl(serverType: string, url: string): string {
    if (serverType === 'other')
      return url;

    return this.apiService.joinUrl(ServerTypes[serverType], url);
  }
}
